import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContextualMenuComponent } from './contextual-menu.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [ContextualMenuComponent],
  exports: [
    ContextualMenuComponent
  ]
})
export class ContextualMenuModule { }
